'use client';
import React, { useState } from 'react';
import { useRouter } from 'next/navigation';
// import Router from 'next/router';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

import CategoryChild from './CategoryChild';
import { useUser } from '@/utils/supabase/useUser';

const NavBarCategories = ({ navBarData }: { navBarData: MenuCategory[] }) => {
  const { user } = useUser();
  const [categoryChildNode, setCategoryChildNode] = useState<CategoryNode>({});
  const [isNodeCollapsed, setIsNodeCollapsed] = useState<
    Record<string, boolean>
  >({});
  const router = useRouter();

  const collapse = (parentName: string) => {
    const collapseElement =
      categoryChildNode[`sectionBoxChildrenFor${parentName}`];
    if (collapseElement.className.includes('--collapseIn')) {
      collapseElement.className = 'section-box__col__body';
      isNodeCollapsed[parentName] = false;
    } else {
      isNodeCollapsed[parentName] = true;
      collapseElement.className += `--collapseIn section-box__col__body`;
    }
    setIsNodeCollapsed({ ...isNodeCollapsed });
  };

  const onClickCategory = (category: MenuCategory) => {
    if (category.child) {
      collapse(category.name);
    } else {
      if (category.name === 'Newsletter' && user) {
        router.push('/my-account/email-preferences');
      } else {
        if (category.link) {
          router.push(category.link);
        }
      }
    }
  };

  return (
    <>
      {navBarData.map((category: MenuCategory) => (
        <div key={`category__${category.name}`} className='section-box__col'>
          <div
            className='section-box__col__header'
            role='button'
            tabIndex={0}
            onKeyDown={() => {
              onClickCategory(category);
            }}
            onClick={() => {
              onClickCategory(category);
            }}
          >
            <div className='section-box__col__title'>
              {category.name}
              {category.child && (
                <span className='nav-link__expand-icon'>
                  {isNodeCollapsed[category.name] ? (
                    <RemoveIcon />
                  ) : (
                    <AddIcon />
                  )}
                </span>
              )}
              <div className='section-box__col__title-underline'>{}</div>
            </div>
          </div>
          <div
            className='section-box__col__body'
            ref={(node) => {
              if (node) {
                const newCategoryChildNode = categoryChildNode;
                newCategoryChildNode[`sectionBoxChildrenFor${category.name}`] =
                  node;
                setCategoryChildNode(newCategoryChildNode);
              }
            }}
          >
            {category.child?.map((subCategory) => (
              <CategoryChild
                key={`category__${subCategory.name}`}
                parent={subCategory}
                className={subCategory.className}
              />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default NavBarCategories;
